import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { Dropdown, Menu } from 'antd'
import c from 'classnames'
import { slide as MenuSlide } from 'react-burger-menu'
import burger from 'images/Menu.svg'
import DropDownIcon from 'images/DropDownIcon.svg'
import { isAdmin, isVenue } from 'utils'
import './index.styl'
import { Search } from '../../components'

const { Item } = Menu

const NavigationMemberLyfe = () => {
  const { pathname } = useLocation()
  const { isMobile, user } = useSelector(state => state.session)
  const [isOpen, setIsOpen] = useState(false)
  const linksPaths = {
    home: '/memberlyfe-home',
    myWallet: user ? '/my-member-wallet' : '/help/overview/my-wallet',
    makeMyPage: user ? '/make-my-memberlyfe' : '/help/overview/make-my-tickets',
    memberOffice: user ? '/member-office/table-members' : '/help/overview/my-box-office',
    memberBackOffice: '/member-back-office',
    userListing: '/member-user-listing',
  }

  const onScroll = () => {
    setIsOpen(false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  const isActive = math => {
    return Array.isArray(math) ? !!math.map(m => pathname.includes(m)).filter(Boolean).length : pathname.includes(math)
  }

  const renderLinkItem = ({ goTo, label, active }) => (
    <Link
      key={goTo}
      to={goTo}
      className={c('link', { active })}
      onClick={onScroll}
    >
      {label}
    </Link>
  )

  const renderSubLinkItem = ({ goTo, label, active }) => (
    <Item key={goTo}>
      <Link
        to={goTo}
        className={c('link', { active })}
        onClick={onScroll}
      >
        {label}
      </Link>
    </Item>
  )

  const mainLinks = [
    { goTo: linksPaths.home, label: 'Home', active: isActive(linksPaths.home) && !pathname.split('/')[1] },
    { goTo: linksPaths.myWallet, label: 'My Wallet', active: isActive(linksPaths.myWallet) },
  ]
  const subLink = [
    { goTo: linksPaths.makeMyPage, label: 'Make My Page', active: isActive(linksPaths.makeMyPage) },
    { goTo: linksPaths.memberOffice, label: 'Member Office', active: isActive(linksPaths.memberOffice) },
  ]

  const adminLink = []
  if (isAdmin(user?.role)) {
    adminLink.push({ goTo: linksPaths.memberBackOffice, label: 'My Back Office', active: isActive(linksPaths.memberBackOffice) })
    adminLink.push({ goTo: linksPaths.userListing, label: 'Users', active: isActive(linksPaths.userListing) })
  }
  if (isVenue(user?.role)) {
    adminLink.push({ goTo: linksPaths.memberBackOffice, label: 'Back Office', active: isActive(linksPaths.memberBackOffice) })
  }

  const menu = (<Menu className='member-sub-menu'>{subLink.map(renderSubLinkItem)}</Menu>)
  const menuBackOffice = (<Menu className='member-sub-menu'>{adminLink.map(renderSubLinkItem)}</Menu>)
  const activeDropDown = isActive(['make-my-tickets', 'my-box-office'])
  const activeDropDownBackOffice = isActive(['user-listing', 'my-back-office'])

  return (
    <div className='mainMemberNavigation'>
      {isMobile ? (
        <MenuSlide
          left
          customBurgerIcon={<img src={burger} className='menu' />}
          onClose={() => setIsOpen(!isOpen)}
          onOpen={() => setIsOpen(!isOpen)}
          burgerButtonClassName='burger-btn'
          isOpen={isOpen}
        >
          <div className='additionalSwitcherWrapper'>
            <Search isSwitcherSearch />
          </div>
          {[...mainLinks, ...subLink, ...adminLink].map(renderLinkItem)}
        </MenuSlide>
      ) : (
        <>
          {mainLinks.map(renderLinkItem)}
          <Dropdown overlay={menu} trigger={['click']} key='SellerTools'>
            <div className='memberDropdownLink'>
              <div className={c('link', 'dropdownLinkText', { activeDropDown })}>Seller Tools</div>
              <img src={DropDownIcon} alt='Drow down icon' className='icon' />
            </div>
          </Dropdown>
          {isAdmin(user?.role)
            ? (
              <Dropdown overlay={menuBackOffice} trigger={['click']} key='BackOffice'>
                <div className='memberDropdownLink'>
                  <div className={c('link', 'dropdownLinkText', { activeDropDownBackOffice })}>Back Office</div>
                  <img src={DropDownIcon} alt='Drow down icon' className='icon' />
                </div>
              </Dropdown>
            ) : (isVenue(user?.role) ? adminLink.map(renderLinkItem) : null)}
          {/* {adminLink.map(renderLinkItem)} */}
        </>
      )}
    </div>
  )
}

export default NavigationMemberLyfe
